export const ESTABLISH_FUND_MODAL_TITLE = "Setup Fund";
export const RESUME_FUND_MODAL_TITLE = "Resume Establishing Fund";
export const SUBMIT_FUND_SUCCESS = "Established Fund Created Successfully ";
